import { createAction } from '@reduxjs/toolkit';

export const showLoadingSpinner = createAction('configuration/show-loading-spinner');
export const hideLoadingSpinner = createAction('configuration/hide-loading-spinner');
export const notFoundError = createAction('configuration/not-found-error');
export const notFoundErrorReset = createAction('configuration/not-found-error-reset');
